import { createFileRoute } from '@tanstack/react-router';
import RolesPage from '@/pages/setup/RolesPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface RolesSearch {
  id?: string;
}

export const Route = createFileRoute('/_authenticated/setup/roles')({
  beforeLoad: () => requireSetupPageAccess('/setup/roles'),
  validateSearch: (raw: Record<string, unknown>): RolesSearch => ({
    id: (raw.id as string) ?? undefined,
  }),
  component: RolesPage,
});
